import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

type FeatureHighlightProps = {
  items: string[];
};

export const FeatureHighlight = ({ items }: FeatureHighlightProps) => {
  const styles = StyleSheet.create({
    featureHighlight: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginVertical: 5,
      gap: 15,
      textAlign: 'center',
    },
    featureHighlightItem: {
      maxWidth: '24%',
    },
    highlightSeparator: {
      width: 1,
      height: 25,
      backgroundColor: 'rgba(186, 208, 221, 1)',
    },
  });

  return (
    <View style={styles.featureHighlight}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <View style={styles.featureHighlightItem}>
            <Text
              style={{ fontSize: 10, textAlign: 'center', fontWeight: 'bold' }}
            >
              {item}
            </Text>
          </View>
          {index < items.length - 1 && (
            <View style={styles.highlightSeparator} />
          )}
        </React.Fragment>
      ))}
    </View>
  );
};
